import { handleActions } from "redux-actions";
import { MERCHANT } from "constants/action-types";
import { IQuery, IMutate, RequestStatus } from "constants/crud";
import {
    ListPurchaseOrderDoorGroupsRequestAction,
    ListPurchaseOrderDoorGroupsCompleteAction,
    CreatePurchaseOrderDoorGroupRequestAction,
    CreatePurchaseOrderDoorGroupCompleteAction,
    UpdatePurchaseOrderDoorGroupRequestAction,
    UpdatePurchaseOrderDoorGroupCompleteAction,
    RemovePurchaseOrderDoorGroupRequestAction,
    RemovePurchaseOrderDoorGroupCompleteAction,
} from "actions/merchant";
import { IPurchaseOrderDoorGroup } from "helpers/delivery-purchase-order";

interface IListState extends IQuery<IPurchaseOrderDoorGroup[]> {}
interface ISingleState extends IMutate<IPurchaseOrderDoorGroup> {}

export interface IState {
    list: IListState;
    single: ISingleState;
}

const initialState: IState = {
    list: {
        queryError: undefined,
        queryStatus: RequestStatus.Active,
        result: [],
    },
    single: {
        mutateStatus: RequestStatus.Idle,
        mutateError: undefined,
        result: undefined,
    },
};

export const merchantPurchaseOrderDoorGroup = handleActions<IState, any>(
    {
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.LIST.REQUEST]: (
            state: IState,
            _action: ListPurchaseOrderDoorGroupsRequestAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...initialState.list,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.LIST.COMPLETE]: (
            state: IState,
            action: ListPurchaseOrderDoorGroupsCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    queryStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                    queryError: action.payload instanceof Error ? action.payload : undefined,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.CREATE.REQUEST]: (
            state: IState,
            action: CreatePurchaseOrderDoorGroupRequestAction
        ): IState => {
            const existing = [...(state.list.result || [])];
            existing[action.payload.index] = action.payload.purchaseOrderDoorGroup as IPurchaseOrderDoorGroup;
            return {
                ...state,
                list: {
                    ...state.list,
                    result: existing,
                },
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.CREATE.COMPLETE]: (
            state: IState,
            action: CreatePurchaseOrderDoorGroupCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.UPDATE.REQUEST]: (
            state: IState,
            _action: UpdatePurchaseOrderDoorGroupRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.UPDATE.COMPLETE]: (
            state: IState,
            action: UpdatePurchaseOrderDoorGroupCompleteAction
        ): IState => {
            return {
                ...state,
                list: {
                    ...state.list,
                    result: action.payload instanceof Error ? undefined : action.payload,
                },
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.SORT.COMPLETE]: (
            state: IState,
            action: UpdatePurchaseOrderDoorGroupCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.REMOVE.REQUEST]: (
            state: IState,
            _action: RemovePurchaseOrderDoorGroupRequestAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateStatus: RequestStatus.Active,
                    mutateError: undefined,
                },
            };
        },
        [MERCHANT.PURCHASE_ORDER_DOOR_GROUP.REMOVE.COMPLETE]: (
            state: IState,
            action: RemovePurchaseOrderDoorGroupCompleteAction
        ): IState => {
            return {
                ...state,
                single: {
                    ...initialState.single,
                    mutateError: action.payload instanceof Error ? action.payload : undefined,
                    mutateStatus: action.error ? RequestStatus.Error : RequestStatus.Idle,
                },
            };
        },
    } as any,
    initialState
);
